(function ($, njm) {
    'use strict';

    njm.views.customSelect = Backbone.View.extend({

        events: {
            'click .selected': 'dropdownClick',
            'click .icon-arrow': 'dropdownClick',
            'keydown .selected': 'dropdownKeydown',
            'keydown .icon-arrow': 'dropdownKeydown',
            'click ul a': 'dropdownSelectionClick',
            'keydown ul a': 'dropdownSelectionKeydown'
        },

        initialize: function () {
            this.dropdown = false;
            this.focusableEls = $('.comp-custom-select ul li a');
            this.firstFocusableEl = this.focusableEls[0];
            this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
            this.focusedEl = false;

            var $this = this;
            var dropdownsList = $('.comp-custom-select');

            dropdownsList.each(function () {
                var currentItem = $(this).find('.selected');

                if (currentItem.attr('data-default-text') !== undefined) {
                    currentItem.val(currentItem.attr('data-default-text'))
                }
            });

            //Hide dropdown with click outside of it
            $(document).click(function (event) {
                if ($(event.target).closest('.comp-custom-select').length === 0) {
                    $this.hideDropdown();
                }
            });


        },


        dropdownClick: function (event) {
            var target = $(event.target);

            if (target.parents('.comp-custom-select').find('.selected').attr('aria-expanded') === 'false') {
                this.hideDropdown();
                this.showDropdown(event);
            } else {
                this.hideDropdown();
            }
        },

        dropdownKeydown: function (event) {
            var key = event.which;
            var target = $(event.target);

            if (key === 13 || key === 32) { //enter or space
                this.dropdownClick(event);
                event.preventDefault();
            }

            if (key === 27) { //escape
                this.hideDropdown();
                target.parents('.comp-custom-select').find('.selected').focus();
            }

            if (key === 38) { //up arrow
                event.preventDefault();
                if (!this.dropdown) {
                    this.showDropdown(event);
                }
                this.focusPrevious();
            }

            if (key === 40) { //down arrow
                event.preventDefault();
                if (!this.dropdown) {
                    this.showDropdown(event);
                }
                this.focusNext();
            }

            if (key === 9) { //tab
                if (this.dropdown) {
                    if (event.shiftKey) {
                        event.preventDefault();
                        this.focusPrevious();
                    } else {
                        event.preventDefault();
                        this.focusNext();
                    }
                }
            }
        },

        dropdownSelectionClick: function (event) {
            var target = $(event.target);
            var parentSelect = target.parents('.comp-custom-select');
            var selectedEl = parentSelect.find('.selected');
            var dataValue = target.parent().attr('data-value');
            var hiddenValue = parentSelect.find('[data-name="custom-select-value"]');

            if (selectedEl.prop('nodeName').toLocaleLowerCase() === 'input') {
                selectedEl.val(target.text()).focus();
            } else {
                selectedEl.text(target.text()).focus();
            }

            hiddenValue.attr('value', dataValue);

            this.hideDropdown();
            //parentSelect.find('.selected').focus();
        },

        dropdownSelectionKeydown: function (event) {
            var key = event.which;
            var target = $(event.target);

            if (key === 13 || key === 32) { //enter or space
                $(event.target).trigger('click');
                event.preventDefault();
            }

            if (key === 27) { //escape
                this.hideDropdown();
                target.parents('.comp-custom-select').find('.selected').focus();
            }

            if (key === 38) { //up arrow
                event.preventDefault();
                this.focusPrevious();
            }

            if (key === 40) { //down arrow
                event.preventDefault();
                this.focusNext();
            }

            if (key === 9) { //tab
                if (event.shiftKey) {
                    event.preventDefault();
                    this.focusPrevious();
                } else {
                    event.preventDefault();
                    this.focusNext();
                }
            }
        },

        hideDropdown: function () {
            var openDropdown = $('.comp-custom-select.open');

            if (openDropdown.length > 0) {
                openDropdown.find('ul').slideUp();
                openDropdown.find('.icon-arrow').removeClass('open');
                openDropdown.find('.selected').attr('aria-expanded', 'false');
                openDropdown.removeClass('open');

                this.dropdown = false;
                this.focusedEl = false;
            }
        },

        showDropdown: function (event) {
            var target = $(event.target);
            var targetSelect = target.parents('.comp-custom-select');

            targetSelect.find('ul').slideDown();
            targetSelect.find('.icon-arrow').addClass('open');
            targetSelect.children('.selected').attr('aria-expanded', 'true');
            targetSelect.addClass('open');

            this.dropdown = true;

            this.focusableEls = target.parents('.comp-custom-select').find('ul li a');
            this.firstFocusableEl = this.focusableEls[0];
            this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        },

        focusNext: function () {
            if (!this.focusedEl) {
                this.firstFocusableEl.focus();
                this.focusedEl = 1;
            } else if (this.focusedEl === this.focusableEls.length) {
                this.firstFocusableEl.focus();
                this.focusedEl = 1;
            } else {
                this.focusableEls[this.focusedEl].focus();
                this.focusedEl++;
            }
        },

        focusPrevious: function () {
            if (this.focusedEl === 1 || !this.focusedEl) {
                this.lastFocusableEl.focus();
                this.focusedEl = this.focusableEls.length;
            } else {
                this.focusedEl--;
                this.focusableEls[this.focusedEl - 1].focus();
            }
        }
    })
    njm.views.customSelectWithSubmit = njm.views.customSelect.extend({
        initialize: function () {
            // Call the parent to do init code.
            njm.views.customSelect.prototype.initialize.apply(this, arguments);
        },

        dropdownSelectionClick: function (event) {
            var target = $(event.target);
            njm.views.customSelect.prototype.dropdownSelectionClick.apply(this, arguments);
            $(target).closest('form').submit();
        }
    });
})(jQuery, njm);
